export const VersionReleaseNote = [
  {
    name: 'V1.0.0',
    label: 'Version 1.0.0',
    date: '31-10-2024',
    tooltip: '',
    children: [
      {
        name: 'vehicle_type',
        label: 'Vehicle Type',
        tooltip: 'Choose a Vehicle Type from Two Available Options: Truck and Trailer',
        children: [
          {
            name: 'compartment',
            label: 'Compartment',
            tooltip: 'Number of Zone in the Box'
          },
          {
            name: 'Model_sel',
            label: 'Model Selection',
            tooltip: 'Choose a Refrigerantion Unit'
          },
        ]
      },
      {
        name: 'outer_box_dimensions',
        label: 'Outer Box Dimensions',
        tooltip: '',
        children: [
          {
            name: 'length',
            label: 'Length',
            tooltip: 'Specify Box Length'
          },
          {
            name: 'width',
            label: 'Width',
            tooltip: 'Specify Box Width'
          },
          {
            name: 'height',
            label: 'Height',
            tooltip: 'Specify Box Height'
          }]
      },
      {
        name: 'vehicle_insulation',
        label: 'Vehicle Insulation',
        tooltip: '',
        children: [
          {
            name: 'specify_insu',
            label: 'Wall UA Calculation Method',
            tooltip: 'Method to Calculate Wall Properties',
            children: [
              {
                name: 'overall_ua',
                label: 'UA Factor',
                tooltip: 'Measured Overall UA',
              },
              {
                name: 'Insulation Material',
                label: 'Insulation Material',
                tooltip: 'Specifify Insulation Material and thickness',
                children: [
                  {
                    name: 'material',
                    label: 'Material',
                    tooltip: 'Insulation Material'
                  },
                  {
                    name: 'thickness',
                    label: 'Thickness',
                    tooltip: 'Insulation Thickness'
                  }
                ]
              },
              {
                name: 'u_value',
                label: 'U Value',
                tooltip: 'Wall U Value'
              }
            ]
          },
          {
            name: 'age_of_body',
            label: 'Age Of Body',
            tooltip: 'Box Age in Years'
          },
          {
            name: 'door_type',
            label: 'Door Type',
            tooltip: 'There are two options in this field: Swing Type and Roll Up. With the different choice, the UA factor of the door is different. Therefore, the corrected UA Factor is calculated and shown at the bottom of this category.',
            children: [
              {
                name: 'swing_type',
                label: 'Swing Type',
                tooltip: 'Swing Type: This is a type of door that swings open.',
                children: [
                  {
                    name: 'hinge_type',
                    label: 'Hinge Type',
                    tooltip: 'Hinge Type: This specifies the type of hinge used in the swing door.'
                  }
                ]
              },
              {
                name: 'roll_up',
                label: 'Roll Up',
                tooltip: 'Roll Up: This is a type of door that rolls up.'
              }
            ]
          },
          {
            name: 'solar_absorptivity',
            label: 'Solar Absorptivity',
            tooltip: 'Shortwave Absorptivity of Opaque Surfaces'
          },
          {
            name: 'emissivity',
            label: 'Emissivity',
            tooltip: 'Longwave Emissivity for all surfaces'
          },
          {
            name: 'infiltration_flowrate',
            label: 'Infiltration Flowrate',
            tooltip: 'Infiltration flowrate (in CFH) at 0.5 inch of water'
          },
          {
            name: 'box_thermal_mass',
            label: 'Box Thermal Mass',
            tooltip: 'Thermal Mass of the Box'
          },
        ]
      },
      {
        name: 'system_control',
        label: 'System Control',
        tooltip: '',
        children: [
          {
            name: 'algorithm',
            label: 'Algorithm',
            tooltip: 'Choose a Control Algorithm'
          },
          {
            name: 'temp_set_point',
            label: 'Temperature Set Point',
            tooltip: 'Set Point Temperature of the Box'
          },
          {
            name: 'restart_band_for_cooling',
            label: 'Restart Band for cooling',
            tooltip: 'Low Speed Cool Restart Switch Point'
          },
          {
            name: 'restart_band_for_heating',
            label: 'Restart Band for heating',
            tooltip: 'Low Speed Heat Restart Switch Point'
          },
          {
            name: 'off_band',
            label: 'Off Band',
            tooltip: 'Controller Lower Start Offset from Set Point'
          },
          {
            name: 'low_high_switch_point',
            label: 'Low High Switch Point',
            tooltip: 'Temperature Cut-off for Speed Switching'
          },
          {
            name: 'hs_wait_time',
            label: 'HS Wait Time',
            tooltip: 'Time Delay After Which Low Speed to High Speed Switch Occurs'
          },

        ]
      },
      {
        name: 'schedule',
        label: 'Schedule',
        tooltip: '',
        children: [
          {
            name: 'route_time',
            label: 'Route Time',
            tooltip: 'Specify Route Time'
          },
          {
            name: 'precool_time',
            label: 'Precool Time',
            tooltip: 'Specify Precool Time'
          },
          {
            name: 'route_profile',
            label: 'Route Profile',
            tooltip: 'Choose a Route Profile from the Five Available Options: Daily Distribution, Constant, Long Haul, Transient, Multi-City Long Haul'
          },
          {
            name: 'time_to_load_product',
            label: 'Time to Load Product',
            tooltip: 'Time to Load/Unload Product'
          },
          {
            name: 'vehicle_speed',
            label: 'Vehicle Speed',
            tooltip: 'Vehicle Speed While in Motion'
          },
          {
            name: 'door_opening_frequency',
            label: 'Door Opening Frequency',
            tooltip: 'Door Opening Per Hour'
          },
          {
            name: 'door_open_time',
            label: 'Door Opening Time',
            tooltip: 'Time Door Remained Open at Each Door Opening'
          },
        ]
      },
      {
        name: 'weather_condtion',
        label: 'Weather Condtion',
        tooltip: '',
        children: [
          {
            name: 'weather_profile',
            label: 'Weather Profile',
            tooltip: 'Choose a Weather Profile from the two Available Options: Constant and Transient'
          },
          {
            name: 'temp_amb',
            label: 'Temperature',
            tooltip: 'Specify Ambient Temperature'
          },
          {
            name: 'solar_flux',
            label: 'Solar Flux',
            tooltip: 'Specify Solar Flux'
          },
          {
            name: 'ambient_pressure',
            label: 'Pressure',
            tooltip: 'Specify Ambient Pressure'
          },
          {
            name: 'RH_amb',
            label: 'Ambient Relative Humidity',
            tooltip: 'Specify Ambient Relative Humidity. Relative humidity must be a ratio between 0 and 1'
          },
          {
            name: 'wind_speed',
            label: 'Effective Wind Speed',
            tooltip: 'Specify Effective Wind Speed. Wind speed must be e watio between 0 and 1'
          },
          {
            name: 'sky_emissivity',
            label: 'Sky Emissivity',
            tooltip: 'Specify Sky Emissivity'
          },
        ]
      },
    ]
  },
  {
    name: 'V1.1.0',
    label: 'Version 1.1.0',
    date: '16-01-2025',
    tooltip: '',
    children: [
      {
        name: 'fcmt_to_ecotrip',
        label: 'Rebranded as ECoTRIP',
        tooltip: 'The tool is now rebranded as ECoTRIP = Energy Consumption and Transport Refrigeration Insight Platform.',
      },
      {
        name: 'export_excel',
        label: 'Export - Results',
        tooltip: 'Export results as Excel file',
      },
      {
        name: 'updated_login_image',
        label: 'Login page image',
        tooltip: 'ThermoKing image for login page background',
      },
      {
        name: 'updated_dimension_value',
        label: 'Default value For Outer Box Dimension',
        tooltip: '',
        children: [
          {
            name: 'Truck',
            label: 'Truck',
            tooltip: 'Default value for truck - Length: 6.8 m, Width: 2.591 m and Height: 2.642 m'
          },
          {
            name: 'Trailer',
            label: 'Trailer',
            tooltip: 'Default value for trailer - Length: 16.154 m, Width: 2.591 m, Height: 2.921 m'
          },
        ]
      },
      {
        name: 'weather_profile',
        label: 'Weather Profile - TMY3',
        tooltip: 'Added new option TMY3',
        children: [
          {
            name: 'landmass',
            label: 'Landmass',
            tooltip: 'Currently the only loaction available is North America'
          },
          {
            name: 'starting_location',
            label: 'Starting Location',
            tooltip: 'Default value for trailer - Length: 16.154 m, Width: 2.591 m, Height: 2.921 m'
          },
          {
            name: 'date_time',
            label: 'Date & Time',
            tooltip: 'User can set the date and time for TMY3 profile'
          },
        ]
      },
    ]
  },
  {
    name: 'V1.1.1',
    label: 'Version 1.1.1',
    date: '19-02-2025',
    tooltip: '',
    children: [
      {
        name: 'removed',
        label: 'Removed PreCool/ PreHeat wait time',
        tooltip: 'Remove preheat/precool wait time, Plugged in new FMU ',
      },
      {
        name: 'add_new row in table',
        label: 'Introduce new Values to result table',
        tooltip: 'when include Emission is true then show - Diesel engine emission, Equivalent electric system emission and Emission reductions',
      },

    ]
  },
  {
    name: 'V1.2.0',
    label: 'Version 1.2.0',
    date: '10-04-2025',
    tooltip: '',
    children: [
      {
        name: 'emission_estimator',
        label: 'Emission Estimator',
        tooltip: '',
        children: [
          {
            name: 'unit_electric_efficiency',
            label: 'Unit Electric Efficiency',
            tooltip: 'The total electric energy consumed by the unit is divided by this efficiency to obtain net energy drawn from the grid for charging the unit.'
          },
          {
            name: 'electric_grid_profile',
            label: 'Electric Grid Profile',
            tooltip: 'It has the option to choose the Europe average , USA average and Manual'
          },
          {
            name: 'lookup',
            label: 'Electric Grid Profile - Lookup',
            tooltip: 'user can able refer the electric profile average lookup based on the selection.'
          },
        ]
      },
      {
        name: 'authenication ',
        label: 'Configure Authentication',
        tooltip: 'Expose the application to internet, and Added OpenId Authentication Login for security purpose',
      },
      {
        name: 'release_note ',
        label: 'Version release note',
        tooltip: 'Added Version release note to document all the features and enhancements',
      },
    ]
  },
  {
    name: 'V1.2.1',
    label: 'Version 1.2.1',
    date: '20-05-2025',
    tooltip: '',
    children: [
      {
        name: 'Move the Production build to AWS Server(NVA-AV-ECOTRIP)',
        label: 'Deployed in AWS',
        tooltip: 'Deployed in AWS Server(NVA-AV-ECOTRIP) and added DNS(https://ecotrip.thermoking.com/).',
      },
      {
        name: 'info ',
        label: 'Information Document',
        tooltip: 'Added Info icon to show all the brief information about the form fields',
      },
    ]
  },
  {
    name: 'V1.3.0',
    label: 'Version 1.3.0 (Current)',
    date: '27-06-2025',
    tooltip: '',
    children: [
      {
        name: 'two_zone ',
        label: 'Compartment - Two Zone',
        tooltip: 'Enable the Partitions and  added zone1, zone2 fields for Product and System Controller',
        children: [
          {
            name: 'include_product',
            label: 'Two Zone - Include Product',
            tooltip: 'Splitted as zone1 product and zone2 product',
          },
          {
            name: 'system_control',
            label: 'Two Zone - System Control',
            tooltip: 'Split Temperature Set Point, Restart Band for cooling ,Restart Band for heating and Off Band as Zone1 and Zone2',
          },
          {
            name: 'Graph plot',
            label: 'Two Zone - Graph plot',
            tooltip: 'Include Return Air Temp Zone1, Return Air Temp Zone2 and changed Engine Speed value as Compressor value',
          },
        ]
      },
      {
        name: 'Testing ',
        label: 'Automated API Testing',
        tooltip: 'Added Automated API testing with jest and setup github workflow automation testing on every Pull Request/PUSH to main',
        },
    ]
  },

]